// extracted by mini-css-extract-plugin
module.exports = {"containerNoFilesUpload":"classes_containerNoFilesUpload__iMMCv","text":"classes_text__3SJ-K"};